/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SearchEvidences200ResponseInnerErrors
 */
export interface SearchEvidences200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerErrors
     */
    'detectedDpi'?: SearchEvidences200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerErrors
     */
    'calculatedDpi'?: SearchEvidences200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerErrors
     */
    'colorGradation'?: SearchEvidences200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerErrors
     */
    'heightMillis'?: SearchEvidences200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchEvidences200ResponseInnerErrors
     */
    'widthMillis'?: SearchEvidences200ResponseInnerErrorsWidthMillisEnum;
}

export const SearchEvidences200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerErrorsDetectedDpiEnum = typeof SearchEvidences200ResponseInnerErrorsDetectedDpiEnum[keyof typeof SearchEvidences200ResponseInnerErrorsDetectedDpiEnum];
export const SearchEvidences200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SearchEvidences200ResponseInnerErrorsCalculatedDpiEnum = typeof SearchEvidences200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof SearchEvidences200ResponseInnerErrorsCalculatedDpiEnum];
export const SearchEvidences200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SearchEvidences200ResponseInnerErrorsColorGradationEnum = typeof SearchEvidences200ResponseInnerErrorsColorGradationEnum[keyof typeof SearchEvidences200ResponseInnerErrorsColorGradationEnum];
export const SearchEvidences200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerErrorsHeightMillisEnum = typeof SearchEvidences200ResponseInnerErrorsHeightMillisEnum[keyof typeof SearchEvidences200ResponseInnerErrorsHeightMillisEnum];
export const SearchEvidences200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SearchEvidences200ResponseInnerErrorsWidthMillisEnum = typeof SearchEvidences200ResponseInnerErrorsWidthMillisEnum[keyof typeof SearchEvidences200ResponseInnerErrorsWidthMillisEnum];


